import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Inject,
  Output,
  ViewChild,
  ViewContainerRef,
  DestroyRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SupportBasedFormComponent } from '../support-based/support-based-form/support-based-form.component';
import { ConnectionMethods, IntegrationMarketingResponse } from '@vendasta/platform-integrations';
import { Oauth2BasedFormComponent } from '../oauth2-based/oauth2-based-form/oauth2-based-form.component';
import { ApikeyBasedComponent } from '../apikey-based/apikey-based-form/apikey-based.component';
import { TranslateModule } from '@ngx-translate/core';
import { PlatformIntegrationsI18nModule } from '@galaxy/platform-integrations/shared';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'platform-integration-dynamic-form',
  imports: [CommonModule, PlatformIntegrationsI18nModule, TranslateModule],
  templateUrl: './dynamic-form.component.html',
  styleUrl: './dynamic-form.component.scss',
})
export class DynamicFormComponent implements AfterViewInit {
  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef })
  dynamicComponentContainer!: ViewContainerRef;

  @Output() saveSyncSettingsEvent = new EventEmitter<any>();

  private dialogRef = inject(MatDialogRef<DynamicFormComponent>);
  private cdRef = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { integration: IntegrationMarketingResponse; integrationDisplayName: string },
  ) {}

  ngAfterViewInit(): void {
    this.loadComponent();
    this.cdRef.detectChanges();
  }

  loadComponent() {
    const formType = this.data.integration.connectionMethod;
    // Create the component dynamically, then pass required config & data
    if (formType === ConnectionMethods.VENDOR_MANAGED) {
      const componentRef =
        this.dynamicComponentContainer.createComponent<SupportBasedFormComponent>(SupportBasedFormComponent);
      componentRef.instance.preconnectFormFields = this.data.integration.preconnectFormFields;
      componentRef.instance.integrationDisplayName = this.data.integration.displayName;
      componentRef.instance.dialogRef = this.dialogRef;
      componentRef.instance.saveSyncSettingsEvent?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        this.saveSyncSettingsEvent.emit(data);
      });
    } else if (formType === ConnectionMethods.OAUTH2) {
      const componentRef =
        this.dynamicComponentContainer.createComponent<Oauth2BasedFormComponent>(Oauth2BasedFormComponent);
      componentRef.instance.preconnectFormFields = this.data.integration.preconnectFormFields;
      componentRef.instance.integrationDisplayName = this.data.integration.displayName;
      componentRef.instance.dialogRef = this.dialogRef;
      componentRef.instance.saveSyncSettingsEvent?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        this.saveSyncSettingsEvent.emit(data);
      });
    } else if (formType === ConnectionMethods.APIKEY) {
      const componentRef = this.dynamicComponentContainer.createComponent<ApikeyBasedComponent>(ApikeyBasedComponent);
      componentRef.instance.preconnectFormFields = this.data.integration.preconnectFormFields;
      componentRef.instance.integrationDisplayName = this.data.integration.displayName;
      componentRef.instance.dialogRef = this.dialogRef;
      componentRef.instance.saveSyncSettingsEvent?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        this.saveSyncSettingsEvent.emit(data);
      });
    }
  }
}
